import { dispatcher } from 'dispatcher';

import { useEffectOnce } from '@core/js/hooks/useEffectOnce';
import { EVENT_PAGE_INFO_READY } from '@interlayer/js/components/system/App/buzz/constants';

export const useSentEventPageInfoReady = (isLoading: boolean) => {
    useEffectOnce(() => {
        setTimeout(() => {
            dispatcher.dispatch(EVENT_PAGE_INFO_READY);
        }, 0);
    }, [isLoading], () => isLoading);
};
